// Arabisch (ar), kioskWeather: zelfde vorm als kioskWeather.nl.ts. Dezelfde woorden als in
// weatherPrayer.ar.ts (weer.feel en weer.itemLabels); nooit een woord over gebed.
export const kioskWeatherAr = {
    title: 'الطقس',
    open: 'الطقس: {feel}. اضغط لمعرفة المزيد.',
    stale: 'الطقس غير معروف الآن',
    today: 'اليوم',
    tomorrow: 'غدًا',
    close: 'إغلاق',
    feel: { cold: 'بارد', chilly: 'منعش', mild: 'لطيف', warm: 'دافئ', hot: 'حار' },
    itemLabels: {
        thick_coat: 'معطف سميك',
        coat: 'جاكيت',
        sweater: 'سترة أو كنزة',
        raincoat: 'معطف مطر',
        boots: 'جزمة',
        hat_gloves: 'قبعة صوف وقفازات',
        umbrella: 'مظلة',
        sunscreen: 'كريم الشمس',
        sun_hat: 'قبعة الشمس',
        water_bottle: 'قارورة ماء',
        shorts: 'سروال قصير',
    },
    day: {
        today: 'هكذا سيكون اليوم',
        tomorrow: 'هكذا سيكون الغد',
        temp: 'كم الحرارة؟',
        tempValue: 'من {min} إلى {max} درجة',
        feels: 'الجو {feel}',
        rain: 'المطر',
        rainWords: {
            dry: 'يبقى الجو جافًا',
            small: 'ربما زخة صغيرة',
            likely: 'قد يأتي المطر',
            wet: 'ستمطر',
        },
        rainWhen: 'من {from} إلى {until}',
        wind: 'الرياح',
        windWords: {
            calm: 'لا رياح تقريبًا',
            light: 'رياح خفيفة',
            fresh: 'رياح لا بأس بها',
            strong: 'رياح قوية',
            very_strong: 'رياح قوية جدًا',
        },
        windForce: 'قوة الرياح {bft}',
        sun: 'الشمس',
        sunrise: 'تشرق {time}',
        sunset: 'تغرب {time}',
        uvWords: {
            moderate: 'الشمس قوية. هل ستبقى طويلًا في الخارج؟ إذن ضع الكريم.',
            high: 'الشمس قوية جدًا. ضع الكريم والقبعة.',
        },
        course: 'كيف سيمضي اليوم؟',
        back: 'رجوع',
        now: 'الآن',
    },
};
//# sourceMappingURL=kioskWeather.ar.js.map